module.exports = __webpack_public_path__ + "img/gallery05.1126cc33.jpg";